import {Component} from '@angular/core';
import {WidgetInputDirective} from '../../directives/widget-input.directive';

@Component({
  selector: 'pt-widget-treatment-data-interested',
  template: `
    <div
      class='widget-border'
      data-testid="widget-treatment-data-interested"
      id='widget_{{initializationWidget.internalId}}'
      [ngSwitch]='initializationWidget?.version'>

      <pt-widget-treatment-data-interested-v0
        *ngSwitchCase='0'
        [initializationWidget]='initializationWidget'
        [lockAcquired]='lockAcquired'
        [status]='status'>
      </pt-widget-treatment-data-interested-v0>

      <pt-widget-version-missing
        *ngSwitchDefault
        [type]='initializationWidget?.type'
        [label]='initializationWidget?.label'
        [version]='initializationWidget?.version'>
      </pt-widget-version-missing>

    </div>
  `
})
export class WidgetTreatmentDataInterestedComponent extends WidgetInputDirective {
}
